<template>
  <div>
    <!--    <div class="manager-bar" v-if="isManager == 1">-->
    <!--      <div v-if="bookManage" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div>-->
    <!--      <div class="manage-set" @click="goManage" v-else>预约管理-->
    <!--        <i class="el-icon-setting"></i>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="container">

      <div class="manager-bar" v-if="isManager == 1">
        <div v-if="bookManage" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div>
        <div class="manage-set" @click="goManage" v-else>预约管理
          <i class="el-icon-setting"></i>
        </div>
      </div>

      <div class="container-c">
        <div class="title">选择参观日期</div>
        <div class="calendar">
          <el-calendar v-model="startDate">
            <template
                slot="dateCell"
                slot-scope="{date, data}">
              <div @click="doSelect(data.day)"
                   :class="(data.day == selectedDate ? 'date-cell is-selected' : 'date-cell') + (data.day >= today ? '' : ' is-closed' ) + (dateList[data.day] === undefined || ( dateList[data.day] !== undefined && dateList[data.day].status === 3 )? ' no-open' : '' )">
                <div class="day">
                  {{ data.day.split('-').slice(2).join('-') }}
                </div>
                <div class="label"
                     :class="dateList[data.day] !== undefined && dateList[data.day].status === 2 ? 'is-full' : ''">
                  <template v-if="data.day < today">
                    已结束
                  </template>
                  <template v-else-if="dateList[data.day] !== undefined">
                    {{ dateList[data.day].label }}
                  </template>
                  <template v-else>
                    未开放
                  </template>
                </div>
              </div>
            </template>
          </el-calendar>
        </div>
        <!-- 预约管理 -->
        <template v-if="bookManage == 1">
          <div class="book-manage">
            <div class="date-switch">
              <div class="label">日期状态</div>
              <el-switch v-model="selectedDateInfo.is_open" @change="handleStatus"></el-switch>
            </div>
            <div class="booked-info">
              <template v-if="selectedDateInfo.is_open">
                <div class="label">人数上限</div>
                <el-input v-model="selectedDateInfo.book_limit" @change="handleLimit"></el-input>
                <div class="booked-amount">当前预约{{ selectedDateInfo.book_amount }}人</div>
              </template>
              <div class="close-label" v-else>当前日期未开放预约</div>
            </div>
            <div class="booked-detail">
              <div class="title">
                <div class="label">预约详情</div>
                <div class="export" @click="handleExport"><i class="el-icon-download"></i> 导出Excel</div>
              </div>
              <div class="user-list">
                <div class="user-item" v-for="(item, index) in bookUsers" :key="index">
                  <div class="number">{{ index + 1 }}</div>
                  <div class="label">身份证</div>
                  <div class="value">{{ item.id_no }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 普通用户预约 -->
        <template v-else>
          <div class="book-title">
            <div class="label">预约人</div>
            <div class="sub-label">（最多3人）</div>
          </div>
          <div class="book-users">
            <div class="item" v-for="(item, index) in users" :key="index">
              <div class="number">{{ index + 1 }}</div>
              <div class="label">身份证</div>
              <el-input v-model="item.id_no" placeholder="点击输入"></el-input>
              <i class="el-icon-close" @click="delItem(index)" v-if="index > 0"></i>
            </div>
            <div class="btn-add" v-if="users.length < 3">
              <div @click="addUser">
                <svg-icon icon-class="add-user"></svg-icon>
                添加预约人
              </div>
            </div>
          </div>
          <div class="btn-sub" @click="submit">
            <div>确认预约</div>
          </div>
        </template>
      </div>
    </div>
    <div class="notice-cont" v-if="showNotice">
      <div class="content">
        <div class="main">
          <div class="title">参观须知</div>
          <div>欢迎参观沈阳建筑大学建筑博物馆，请遵守以下规定：</div>
          <div class="p weight">
            开放时间及费用：
          </div>
          <div>
            公众开放时间为法定节假日 9:00-17:00，对所有参观者免费开放。
          </div>
          <div class="p weight">
            入场与规范：
          </div>
          <div class="red">预约成功后，请务必携带本人身份证原件，否则无法入校。</div>
          <div>
            <span class="red">校园内机动车辆限速30km/h以内，严禁超速行驶，违者将被列入黑名单，禁止以后申请入校。</span>
            馆内禁止携带轮滑鞋、自行车、儿童滑板车等物品。请勿触摸展品，禁止饮食和携带危险品。
          </div>
          <div class="p">
            感谢配合，祝您参观愉快！
          </div>
          <div>
            如有疑问，请联系致电：24690010。
          </div>
        </div>
        <div class="agree" @click="showNotice = false">同意</div>
      </div>
    </div>
  </div>
</template>
<script>
import {getDays, books, getDateInfo, editStatus, editLimit, bookList, checkManager, exports} from '@/api/home'
import {downloadFile} from '@/utils/index'

export default {
  components: {},
  data() {
    return {
      dateList: {},
      users: [{'id_no': ''}],
      isManager: 0, //是否是管理员
      bookManage: 0, //预约管理
      selectedDate: '', //当前选中日期
      today: '',
      selectedDateInfo: {
        is_open: 0,
        book_limit: 500,
        book_amount: 0,
      },
      bookUsers: [],
      token: '',
      curMonth: '',
      showNotice: true,
      startDate: ''
    }
  },
  watch: {
    $route: {
      handler(nv, ov) {
      },
      deep: true,
      immediate: true,
    },
  },
  beforeCreate() {
  },
  created() {

    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 需要补零
    let day = String(currentDate.getDate()).padStart(2, '0');
    this.today = year + "-" + month + "-" + day
    this.curMonth = currentDate.getMonth() + 1

    // //鉴权
    let token = this.$route.query.token
    if (token) {
      this.token = token
      this.days()
      this.getManage()
    } else {
      window.location.href = process.env.VUE_APP_API_URL + '/sjd/auth'
    }
  },
  beforeDestroy() {

  },
  beforeMount() {
  },
  destroyed() {

  },
  mounted() {

  },
  methods: {
    delItem(index) {
      this.users.splice(index, 1)
    },
    getManage() {
      checkManager({token: this.token}).then(res => {
        if (res.data.is_manager === 1) {
          this.isManager = 1
        }
        if (res.data.has_book === 1) {
          this.$router.push({path: '/books', query: {token: this.token}})
        }
      })
    },
    days(selected = true) {
      getDays({token: this.token}).then(res => {
        this.dateList = res.data
        if (selected) {
          //this.selectedDate = Object.keys(res.data)[0]
          //this.startDate = Object.keys(res.data)[0]
          this.getFirstDate()
        }
        if (this.bookManage == 1) {
          this.getInfo()
        }
      })
    },
    //自动选择第一个可以约的日期
    getFirstDate() {
      for (let i in this.dateList) {
        if (this.dateList[i].status == 1) {
          this.selectedDate = i
          this.startDate = i
          return true
        }
      }
    },
    doSelect(date) {
      //管理员可以编辑任何一个时间
      if (this.bookManage == 1) {
        // if (date < this.today) {
        //   return false
        // }

        this.selectedDate = date
        this.getInfo()
        this.getList()
        return true;
      }


      if (this.dateList[date] !== undefined) {

        if (this.dateList[date].status == 1) {
          this.selectedDate = date
        }

        // if (this.bookManage == 1) {
        //   this.selectedDate = date
        //   this.getInfo()
        //   this.getList()
        // } else {
        //   if (this.dateList[date].status == 1) {
        //     this.selectedDate = date
        //   }
        // }


      }
    },
    getInfo() {
      getDateInfo({dates: this.selectedDate, token: this.token}).then(res => {
        this.selectedDateInfo = res.data
        console.log(res.data)
      })
    },
    addUser() {
      if (this.users.length >= 3) {
        return false;
      }
      this.users.push({'id_no': ''})
    },
    //预约管理
    goManage() {
      if (this.isManager == 1) {
        this.bookManage = 1
        this.getInfo()
      }

    },
    //返回
    goBack() {
      this.bookManage = ''
    },
    //提交预约
    submit() {
      books({dates: this.selectedDate, users: this.users, token: this.token}).then(res => {
        this.$router.push({path: '/books', query: {token: this.token}})
      }).catch(error => {
        console.log(error)
      })
    },
    //修改开发状态
    handleStatus(e) {
      editStatus({dates: this.selectedDate, is_open: e, token: this.token}).then(res => {
        this.days(false)
      }).catch(error => {
        console.log(error)
      })
    },
    //修改人数上限
    handleLimit() {
      editLimit({
        dates: this.selectedDate,
        book_limit: this.selectedDateInfo.book_limit,
        token: this.token
      }).then(res => {
        this.days(false)
      }).catch(error => {
        console.log(error)
      })
    },
    getList() {
      bookList({dates: this.selectedDate, token: this.token}).then(res => {
        this.bookUsers = res.data
      })
    },
    //导出excel
    handleExport() {
      exports({dates: this.selectedDate, token: this.token}).then(res => {
        console.log(res)
        this.doDownload(res.data.url, '预约列表' + this.selectedDate + '.xlsx')
      })
    },

    doDownload(url, name) {
      console.log('start download ')

      location.href = url;
      return false

      //这种方式，安卓在微信浏览器会下载不了
      //downloadFile(url, name)
    },
    handleHeader() {
      this.$nextTick(() => {
        // 点击前一个月
        let prevBtn = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(1)"
        );
        prevBtn.addEventListener("click", (e) => {
          //this.curMonth = this.curMonth - 1
        });
        //点击下一个月
        let nextBtn = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(3)"
        );
        nextBtn.addEventListener("click", (e) => {

          //this.curMonth = this.curMonth + 1
        });

      });
    },

  },
}
</script>

<style lang="less" scoped>
.red {
  color: red;
  font-weight: bold;
}

.manager-bar {
  width: 100%;
  height: 38px;
  background: var(---, #3E4551);
  border-bottom: 0.5px solid #E2E4E9;
  color: #fff;
  display: flex;
  align-items: center;

  > div {
    display: flex;
    align-items: center;
  }

  .el-icon-arrow-left {
    font-size: 20px;
    margin: 0 4px 0 16px;
  }

  .manage-set {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: right;
    padding: 0 18px 0 0;
    box-sizing: border-box;

    i {
      font-size: 18px;
      margin: 0 0 0 4px;
    }
  }
}

.container {
  max-width: 750px;
  margin: 0 auto;

  position: relative;
  min-height: 100vh;
  overflow-y: auto;

  .container-c {
    padding: 0 18px 80px 18px;

    > .title {
      font-size: 14px;
      line-height: 40px;
      font-weight: 600;
      color: #10141B;
      border-bottom: 1px solid #E2E4E9;
    }
  }


  .book-manage {

    .date-switch {
      line-height: 40px;
      font-size: 14px;
      border-bottom: 1px solid #E2E4E9;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 30px 0 0 0;
      font-weight: 600;
    }

    .booked-info {
      display: flex;
      align-items: center;
      height: 52px;

      .close-label {
        color: var(---, #787D86);
      }

      .label {
        width: 80px;
        flex-shrink: 0;
      }

      .booked-amount {
        width: 159px;
        color: var(---, #787D86);
        text-align: right;
        flex-shrink: 0;
      }

      /deep/ .el-input {
        .el-input__inner {
          height: 28px;
          border-radius: 4px;
          background: #F8F9FA;
        }
      }

    }

    .booked-detail {
      .title {
        height: 40px;
        margin: 36px 0 0 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(---normal, #E2E4E9);

        .label {
          font-weight: 600;
        }

        .export {
          display: flex;
          align-items: center;
          color: var(---, #4D5BDE);

          i {
            font-size: 18px;
            margin: 0 4px 0 0;
          }
        }
      }

      .user-list {
        margin: 6px 0 0 0;

        .user-item {
          height: 40px;
          display: flex;
          align-items: center;
          color: var(---, #3E4551);

          .number {
            width: 30px;
            flex-shrink: 0;
          }

          .label {
            width: 70px;
            margin: 0 10px 0 0;
          }

          .value {
            flex: 1;
          }
        }
      }
    }
  }


  .book-title {
    line-height: 40px;
    font-size: 14px;
    border-bottom: 1px solid #E2E4E9;
    display: flex;
    margin: 16px 0 10px 0;

    .label {
      color: #10141B;
      font-weight: 600;
    }

    .sub-label {
      color: #ADB1BA;
    }

  }

  .book-users {
    display: flex;
    flex-direction: column;

    .item {
      width: 100%;
      display: flex;
      height: 40px;
      align-items: center;

      .number {
        width: 30px;
        flex-shrink: 0;
      }

      .label {
        width: 70px;
        flex-shrink: 0;
      }

      i {
        font-size: 18px;
        padding: 0 0 0 8px;
        cursor: pointer;
        color: #ADB1BA;
      }

      /deep/ .el-input {


        .el-input__inner {
          height: 28px;
          border-radius: 4px;

          background: #F8F9FA;
        }
      }

    }

    .btn-add {
      display: flex;
      height: 40px;
      align-items: center;
      color: #4D5BDE;
      cursor: pointer;

      > div {
        display: flex;
        align-items: center;
      }

      svg {
        margin: 0 4px 0 0;
      }
    }
  }

  .btn-sub {
    width: 100%;
    position: absolute;
    bottom: 30px;
    left: 0;
    cursor: pointer;

    > div {
      height: 44px;
      border-radius: 42px;
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      margin: 0 18px;
      background: var(---, linear-gradient(94deg, #9D40FB 0.85%, #405DF6 99.77%));

      color: #fff;
    }

  }

  /deep/ .el-calendar__header {
    border-bottom: none;
    padding: 10px 0;

    .el-button:focus, .el-button:hover {
      background: #fff;
      color: #606266;
      border: 1px solid #DCDFE6 !important;
    }
  }

  /deep/ .el-calendar__body {
    padding: 0;
  }

  /deep/ .el-calendar-table td {
    border: none;
    border-radius: 10px;
  }

  /deep/ .el-calendar-table thead th {
    padding: 10px 0;
  }

  /deep/ .el-calendar-table td.is-selected {
    background: transparent;
  }

  /deep/ .date-cell.is-selected {
    background: #4D5BDE;
    color: #fff;
    overflow: hidden;
    border-radius: 10px;


    .day, .label {
      color: #fff !important;
    }
  }

  /deep/ .el-calendar-table .current.is-selected .el-calendar-day:hover {
    background: transparent;
  }

  /deep/ .el-calendar-table__row .prev .el-calendar-day, /deep/ .el-calendar-table__row .next .el-calendar-day {
    display: none;
  }

  ::v-deep {
    .el-calendar-table:not(.is-range) td.next, .el-calendar-table:not(.is-range) td.prev {
      pointer-events: none;
    }
  }

  /deep/ .el-calendar__button-group button:nth-child(2) {
    display: none;
  }

  /deep/ .el-calendar-table__row {
    margin: 0 0 4px 0;
  }

  /deep/ .el-calendar-table {
    thead th {
      color: #ADB1BA;
      font-weight: 600;
    }
  }

  /deep/ .el-calendar__title {
    font-weight: 600;
  }

  /deep/ .el-calendar-table .el-calendar-day {
    height: 40px;
    padding: 0;

    .date-cell {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 40px;
      line-height: 16px;

      &.is-closed, &.no-open {
        color: #ADB1BA !important;

        .day {
          color: #ADB1BA !important;

        }
      }

      .day {
        font-weight: 600;
        color: #000;
      }

      .label {
        font-size: 10px;

        &.is-full {
          color: #D60113;
        }
      }
    }
  }


}

.notice-cont {
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;

  background: rgba(255, 255, 255, 0.70);

  backdrop-filter: blur(2px);
  display: flex;
  flex-direction: column;
  justify-content: center;

  .content {
    width: 328px;
    //height: 370px;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    border: 0.5px solid #D6D8DC;
    box-shadow: 0px 2px 12px 0px rgba(68, 73, 77, 0.13);
    overflow: hidden;

    .main {
      width: 100%;
      //height: 320px;
      background: var(---bg_hover, #F8F9FA);
      display: flex;
      flex-direction: column;
      padding: 0 12px 20px 12px;
      color: var(---, #3E4551);
      font-size: 13px;

      .title {
        width: 100%;
        text-align: center;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
        color: var(---, #000);
        margin: 18px 0 10px;
      }

      .p {
        margin: 16px 0 0 0;

        &.weight {
          font-weight: 600;
        }
      }

    }

    .agree {
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      font-weight: 500;
      color: var(---, #4D5BDE);
      border-top: 0.5px solid var(---normal, #E2E4E9);
      cursor: pointer;
    }

  }
}
</style>
